import { Controller } from "@hotwired/stimulus"

// Initialize Bootstrap carousel with custom settings
export default class extends Controller {
  connect() {
    // Dynamic import so Bootstrap only loads if this controller is on the page
    import("bootstrap").then((bs) => {
      const carousel = this.element
      if (carousel && bs.Carousel) {
        bs.Carousel.getOrCreateInstance(carousel, {
          interval: 6000,
          ride: "carousel",
          pause: "hover",
          wrap: true,
          touch: true,
        })
      }
    })
  }
}
